module.exports = __webpack_public_path__ + "static/media/widgets-bck.717abc77.png";